import React, { Component } from 'react';
import { Table, Input, Tag, Space, Select, Form, DatePicker, TimePicker,message, Button, Switch, Upload, Modal } from "antd";
import SimpleReactValidator from "simple-react-validator";
import { getDonationCategories, getData } from "../../actions/index";
import { connect } from "react-redux";
import { getSitesByuser, getUserSites, getGroupBySite, getHandlersBySite, getAllActiveUsers, getSiteAccessBaseData, siteAccessCreate, getAccessPermitionRequestById, siteAccessEdit } from "../../api/index";
import { PlusCircleOutlined, DeleteOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import _ from "lodash";
import { withRouter } from 'react-router-dom'
import ReactLoading from 'react-loading';
import * as XLSX from "xlsx";


//import SimpleReactValidator from 'simple-react-validator';

const format = 'HH:mm';
const valuesArrObj = [];
const valuesArrObjInst = [];
const valuesArrObjVhe = [];
const valuesArrObjVisitor = [];

const AllDataObject = [];
// const [form] = Form.useForm();
const importExcel = (file, addItem) => {
    const fileReader = new FileReader();
    fileReader.onload = event => {
        try {
            const { result } = event.target;
            const workbook = XLSX.read(result, { type: "binary" });
            for (const Sheet in workbook.Sheets) {
                // var XL_row_object =
                XLSX.utils.sheet_to_row_object_array(workbook.Sheets['Sheet1']);
                if (workbook.Sheets.hasOwnProperty(Sheet)) {

                    XLSX.utils.sheet_to_row_object_array(workbook.Sheets[Sheet]).forEach(x => {
                        addItem(x.Name, x.ContactNumber, x.Nic, x.Company);
                    });
                }
            }
            message.success("upload success!");
        } catch (e) {
            message = message.error("file type is incorrect!");
        }
    };
    fileReader.readAsBinaryString(file);
};
class Edit extends Component {

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.validatorequ = new SimpleReactValidator();
        this.validatorins = new SimpleReactValidator();
        this.validatorNewuser = new SimpleReactValidator();


        this.state = {

            allSite: [],
            AllHandlersBySite: [],
            AllUsers: [],
            allSite_loading: true,
            submit_loading: false,
            selectedSiteId: "",
            selectedHandler: "",
            selectedGroupId: "",
            selectedGroupName: "",
            equ_itemName: "",
            equ_sirialNum: "",
            equ_actionType: "",
            equ_description: "",
            equ_qty: "",
            equipmentArray: [],
            ins_itemName: "",
            ins_sirialNum: "",
            ins_actionType: "",
            ins_description: "",
            ins_qty: "",
            insArray: [],
            vhe_no: "",
            vhe_type: "",

            selectWorkArea: [],
            selectWorkType: [],
            vheArray: [],
            SiteAccessBaseDataVisitingPurposes: [],
            SiteAccessBaseDataAccessNeed: [],
            SiteAccessBaseDatarelatedTechnologys: [],
            referenceNo: null,
            workDescription: null,
            scheduleType: {
                "id": 1
            },
            operationType: { "id": 1 },
            visitingPurpose: null,
            accessNeed: null,
            relatedTechnology: null,
            sites: [],
            handler: {
                "id": 170
            },
            scheduleStartOn: null,
            scheduleEndOn: null,
            dayOfWeek: "",
            dayOfMonth: "",
            accessDate: moment().format('YYYY-MM-DD'),
            accessEndDate: moment().format('YYYY-MM-DD'),
            accessStartOn: moment().format("HH:mm"),
            workDuration: "",
            visitors: [],
            equipments: [],
            instruments: [],
            accessVehicles: [],
            alldataset: [],
            isOpen: false,
            recurrentStatus: false,
            EditsiteArry: null,
            haddalerArry: null,
            editEoperationType: null,
            editScheduleType: null,
            editDayOfWeek: null,
            editDayOfMonth: null,
            editAccessDate: null,
            editAccessEndDate: null,
            editAccessStartOn: null,
            editScheduleStartOn: null,
            editScheduleEndOn: null,
            editVisitors: null,
            editVisitorArray: [],
            siteAccessId: null,
            newUserName: null,
            newUserCompany: null,
            newUserConNum: null,
            newUsernic: null,
            workArea: null,
            workType: null,
            workRemarks: null,
            selectOpararionType: 1,
            projectName: "",
            scopeOfWork: "",
            downTimeRequiredDate: null,
            nameOfTeamLeader: "",
            contactNoOfTeamLeader: '',
            uploadFiles: [],
            fileList: [],
            editfileList: [],
            previewVisible: false,
            previewImage: "",


        };
        this.handleChangeItmeName = this.handleChangeItmeName.bind(this);
        this.handleChangeActionType = this.handleChangeActionType.bind(this);
        this.handleChangeSerialNum = this.handleChangeSerialNum.bind(this);
        this.handleChangeDescription = this.handleChangeDescription.bind(this);
        this.handleChangetUserName = this.handleChangetUserName.bind(this);
        this.handleChangetUserCompany = this.handleChangetUserCompany.bind(this);
        this.handleChangetUserContactNumber = this.handleChangetUserContactNumber.bind(this);
        this.handleChangetUserNic = this.handleChangetUserNic.bind(this);
        this.handleChangeQty = this.handleChangeQty.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitNewUser = this.handleSubmitNewUser.bind(this);


        this.handleChangeInsItmeName = this.handleChangeInsItmeName.bind(this);
        this.handleChangeInsActionType = this.handleChangeInsActionType.bind(this);
        this.handleChangeInsSerialNum = this.handleChangeInsSerialNum.bind(this);
        this.handleChangeInsDescription = this.handleChangeInsDescription.bind(this);
        this.handleChangeInsQty = this.handleChangeInsQty.bind(this);
        this.handleInsSubmit = this.handleInsSubmit.bind(this);

        this.handleChangeVheNo = this.handleChangeVheNo.bind(this);
        this.handleChangeVheType = this.handleChangeVheType.bind(this);
        this.handleVheSubmit = this.handleVheSubmit.bind(this);

        this.handleChangeRefNo = this.handleChangeRefNo.bind(this);
        this.handleChangeWorkDes = this.handleChangeWorkDes.bind(this);
        this.handleChangeDuration = this.handleChangeDuration.bind(this);
        this.handleRemarks = this.handleRemarks.bind(this);

        this.handleProjectName = this.handleProjectName.bind(this);
        this.handleScopeofWork = this.handleScopeofWork.bind(this);
        this.handleNameofTeamLeader = this.handleNameofTeamLeader.bind(this);
        this.handleContactNoofTeamLeader = this.handleContactNoofTeamLeader.bind(this);


    }


    componentDidMount() {
        this.props.getData();
        this.getDataSitesByuser();
        this.getDataAllActiveUsers();
        this.getDataSiteAccessBaseData();

        //only edit
        var form = new FormData();

        //console.log(this.props.match.params)

        if (this.props.match.params?.value) {
            //console.log('this.props.match.params?.value')
            //console.log(this.props.match.params?.value)

        }
        form.append("accessPermitionRequestId", this.props.match.params.id);
        this.getDataAccessPermitionRequestById(form);

    }
    getDataAllActiveUsers = async () => {
        var res = await getAllActiveUsers();
        //console.log("getAllActiveUsers");
        //console.log(res.data);
        if (res.success) {
            this.setState({

                AllUsers: res.data,
            });
        }
    };
    getDataAccessPermitionRequestById = async (data) => {
        //console.log(data);
        var res = await getAccessPermitionRequestById(data);
        //console.log("getAccessPermitionRequestById22");
        //console.log(res);


        if (res.success) {
            var today = new Date();
            //console.log(res.data.workDuration);
            var form = new FormData();
            form.append("siteId", res.data.sites[0].id);
            this.getDataHandlersBySite(form);
            if (res.data.scheduleStartOn != null) {

                this.setState({
                    recurrentStatus: true,
                    scheduleStartOn: res.data.scheduleStartOn,
                    editScheduleStartOn: res.data.scheduleStartOn,

                    scheduleEndOn: res.data.scheduleEndOn,
                    editScheduleEndOn: res.data.scheduleEndOn
                })
            }
            if (res.data.visitors != null) {

                //console.log("res.data.visitors");
                //console.log(this.state.AllUsers);
                res.data.visitors.filter(visitors2 => visitors2.active == true).map((item, index) => {
                    this.state.editVisitorArray.push(item.user?.id)
                })

                this.setState({
                    visitors: res.data.visitors,
                    editVisitors: res.data.visitors,
                })

            }
            if (res.data.remarks != null) {
                this.setState({
                    workRemarks: res.data.remarks
                })
            }
            if (res.data.referenceNo != null) {
                this.setState({
                    referenceNo: res.data.referenceNo
                })
            }

            // scopeofWork: "",
            // downTimeRequiredDate: "",
            // nameofTeamLeader: "",
            // contactNoofTeamLeader: '',
            if (res.data.contactNoOfTeamLeader != null) {
                this.setState({
                    contactNoOfTeamLeader: res.data.contactNoOfTeamLeader
                })
            }
            if (res.data.nameOfTeamLeader != null) {
                this.setState({
                    nameOfTeamLeader: res.data.nameOfTeamLeader
                })
            }
            if (res.data.downTimeRequiredDate != null) {
                this.setState({
                    downTimeRequiredDate: res.data.downTimeRequiredDate
                })
            } else {
                this.setState({
                    downTimeRequiredDate: '',
                })
            }
            if (res.data.projectName != null) {
                this.setState({
                    projectName: res.data.projectName
                })
            }
            if (res.data.scopeOfWork != null) {
                //console.log(res.data.scopeOfWork);
                //console.log("scopeOfWork12");
                this.setState({
                    scopeOfWork: res.data.scopeOfWork
                })
            }

            if (res.data.workDescription != null) {
                this.setState({
                    workDescription: res.data.workDescription
                })
            }
            if (res.data.visitingPurpose != null) {
                this.setState({
                    visitingPurpose: { "id": res.data.visitingPurpose.id }
                })

            }
            if (res.data.workType != null) {
                this.setState({
                    workType: { "id": res.data.workType.id }
                })

            }
            if (res.data.workArea != null) {
                this.setState({
                    workArea: { "id": res.data.workArea.id }
                })

            }
            if (res.data.accessNeed != null) {
                this.setState({
                    accessNeed: { "id": res.data.accessNeed.id }
                })

            }
            if (res.data.relatedTechnology != null) {
                this.setState({
                    relatedTechnology: { "id": res.data.relatedTechnology.id }
                })

            }
            if (res.data?.files != null) {
                var _filesList = [];
                res.data?.files.map((item, index) => {
                    _filesList.push({ 'uid': (index + 1).toString(), 'name': item, 'status': 'done', 'size': 43852, 'type': "image/png", 'url': 'https://storage.googleapis.com/dns_storage_v2/requestimages/' + item })
                })
                //console.log('newIsu');
                //console.log(res.data?.files);

                this.setState({
                    editfileList: res.data?.files,
                    fileList: _filesList,
                    uploadFiles: _filesList
                })
            }
            if (res.data.equipments[0] != null) {

                res.data.equipments.map((item, key) => {
                    valuesArrObj.push(item)
                })
                //  valuesArrObj=this.state.equipments


            }
            if (res.data.visitors[0] != null) {

                res.data.visitors.map((item, key) => {
                    valuesArrObjVisitor.push(item)
                })
                //  valuesArrObj=this.state.equipments


            }
            if (res.data.instruments[0] != null) {

                res.data.instruments.map((item, key) => {
                    valuesArrObjInst.push(item)
                })
                //  valuesArrObj=this.state.equipments


            }
            if (res.data.accessVehicles[0] != null) {

                res.data.accessVehicles.map((item, key) => {
                    valuesArrObjVhe.push(item)
                })
                //  valuesArrObj=this.state.equipments


            }
            this.setState({
                siteAccessId: res.data.id,
                EditsiteArry: res.data.sites[0].id,
                sites: [{ 'id': res.data.sites[0].id }],
                selectedGroupName: res.data.accessPerminionGroupName,
                selectedGroupId: res.data.accessPerminionGroupId,
                haddalerArry: res.data.handlerId,
                handler: { 'id': res.data.handlerId },

                editEoperationType: res.data.operationType.name,
                operationType: { 'id': res.data.operationType.id },
                selectOpararionType: res.data.operationType.id,

                scheduleType: { 'id': res.data.scheduleType.id },
                editScheduleType: res.data.scheduleType,

                accessStartOn: res.data.accessStartOn,
                editAccessStartOn: res.data.accessStartOn,

                workDuration: (res.data.workDuration / 60),
                equipments: res.data.equipments,
                instruments: res.data.instruments,
                accessVehicles: res.data.accessVehicles






            });
            if (res.data.accessDate) {
                this.setState({
                    accessDate: res.data.accessDate,
                    editAccessDate: res.data.accessDate,
                })
            } else {

                this.setState({

                    editAccessDate: moment().format('YYYY-MM-DD'),
                })
            }
            if (res.data.accessEndDate) {
                this.setState({
                    accessEndDate: res.data.accessEndDate,
                    editAccessEndDate: res.data.accessEndDate,
                })
            } else {

                this.setState({

                    editAccessEndDate: moment().format('YYYY-MM-DD'),
                })
            }
            if (res.data.dayOfWeek != null) {
                this.setState({
                    dayOfWeek: res.data.dayOfWeek,
                    editDayOfWeek: res.data.dayOfWeek,
                })

            } else {
                this.setState({
                    // dayOfWeek:res.data.dayOfWeek,
                    editDayOfWeek: today.getDay().toString(),
                })
            }
            if (res.data.dayOfMonth != null) {
                this.setState({
                    dayOfMonth: res.data.dayOfMonth,
                    editDayOfMonth: res.data.dayOfMonth,
                })

            } else {
                this.setState({
                    // dayOfWeek:res.data.dayOfWeek,
                    editDayOfMonth: today.getUTCDate().toString()
                })
            }







        }
    };


    getDataSitesByuser = async () => {
        var res = await getUserSites();
        //console.log("getUserSites");
        //console.log(res.data);
        if (res.success) {
            this.setState({
                allSite_loading: false,
                allSite: res.data,
            });
        }
    };
    getDataSiteAccessBaseData = async () => {
        var res = await getSiteAccessBaseData();
        //console.log("getSiteAccessBaseData");
        //   //console.log(res.data.visitingPurposes);
        if (res.success) {
            this.setState({
                //allSite_loading: false,
                SiteAccessBaseDataVisitingPurposes: res.data.visitingPurposes,
                SiteAccessBaseDataAccessNeed: res.data.accessNeeds,
                selectWorkArea: res.data.workAreas,
                selectWorkType: res.data.workTypes,
                SiteAccessBaseDatarelatedTechnologys: res.data.relatedTechnologys
            });
        }
    };

    getDataGroupBySite = async (data) => {
        var res = await getGroupBySite(data);
        //console.log("getGroupBySite");
        //console.log(res.data);
        if (res.success) {
            //console.log("getGroupBySitessssssssssssssss");

            this.setState({
                selectedGroupId: res.data.id,
                selectedGroupName: res.data.name
            })
        }

    };
    getDataHandlersBySite = async (data) => {
        var res = await getHandlersBySite(data);
        //console.log("getHandlersBySite");
        //console.log(res.data);
        if (res.success) {


            this.setState({
                AllHandlersBySite: res.data
            })
        }

    };

    onChangeSite = (value) => {
        //console.log("onChangeSite");
        //console.log(value);
        this.setState({
            selectedSiteId: value,
            sites: [{
                "id": value
            }],
            AllHandlersBySite: []
        })
        var form = new FormData();
        form.append("siteId", value);
        this.getDataGroupBySite(form);
        this.getDataHandlersBySite(form);
    };
    onChangeHandler = (value) => {
        //console.log("onChangeHandler");
        //console.log(value);
        this.setState({
            selectedHandler: value,
            handler: { "id": value }
            //  AllHandlersBySite: []
        })

    };
    onChangeScheduleType = (value) => {
        //console.log("onChangeScheduleType");
        //console.log(value);
        this.setState({
            scheduleType: { "id": value },
        })

    };
    onChangeDownTimeRequiredDate = (date, dateString) => {
        //console.log(date);
        //console.log(dateString);
        if (dateString != "") {

            this.setState({
                downTimeRequiredDate: moment(dateString).format('YYYY-MM-DD'),
            });
        } else {

            this.setState({
                downTimeRequiredDate: null
            });
        }

    };
    onChangeOperationType = (value) => {
        //console.log("onChangeOperationType");
        //console.log(value);
        this.setState({
            operationType: { "id": value },
            selectOpararionType: value
        })

    };
    OnChangeRecurrent = (value) => {



        if (value == true) {
            var Firsttoday = new Date();

            // this.setState({
            //     dayOfWeek: Firsttoday.getDay().toString(),
            //     dayOfMonth: Firsttoday.getUTCDate().toString()
            // })
            this.setState({
                recurrentStatus: value,
                scheduleEndOn: moment().format('YYYY-MM-DD'),
                scheduleStartOn: moment().format('YYYY-MM-DD'),
                scheduleType: { 'id': 2 },
                dayOfWeek: Firsttoday.getDay().toString(),
                dayOfMonth: Firsttoday.getUTCDate().toString()




            })
        } else {
            this.setState({
                recurrentStatus: value
            })
        }


        //console.log(`switch to ${value}`);

    };
    onChangeVisitingPurpose = (value) => {
        //console.log("onChangeVisitingPurpose");
        //console.log(value);
        this.setState({
            visitingPurpose: { "id": value },
        })

    };
    onChangeWorkArea = (value) => {
        //console.log("onChangeWorkArea");
        //console.log(value);
        this.setState({
            workType: { "id": value },
        })

    };
    onChangeWorkType = (value) => {
        //console.log("onChangeWorkType");
        //console.log(value);
        this.setState({
            workArea: { "id": value },
        })

    };
    onChangeAccessNeed = (value) => {
        //console.log("onChangeAccessNeed");
        //console.log(value);
        this.setState({
            accessNeed: { "id": value },
        })

    };
    onChangerelatedTechnology = (value) => {
        //console.log("onChangerelatedTechnology");
        //console.log(value);
        this.setState({
            relatedTechnology: { "id": value },
        })

    };

    onChangeScheduleStartOn = (date, dateString) => {
        //console.log(date);
        //console.log(dateString);
        this.setState({
            scheduleStartOn: dateString,
        });
    };
    onChangeScheduleEndOn = (date, dateString) => {
        //console.log(date);
        //console.log(dateString);
        this.setState({
            scheduleEndOn: dateString,
        });
    };
    onChangeAccessEndDate = (date, dateString) => {
        //console.log(date);
        //console.log(dateString);
        this.setState({
            accessEndDate: moment(dateString).format('YYYY-MM-DD'),
        });
    };
    onChangeAccessDate = (date, dateString) => {
        //console.log(date);
        //console.log(dateString);
        this.setState({
            accessDate: moment(dateString).format('YYYY-MM-DD'),
        });
    };
    onChangeAccessStartOn = (date, dateString) => {
        //console.log(date);
        //console.log(dateString);
        this.setState({
            accessStartOn: dateString,
        });
    };
    onChangeDayOfWeek = (value) => {
        //console.log("onChangeDayOfWeek");
        //console.log(value);
        this.setState({
            dayOfWeek: value,
            //dayOfMonth:'',
        })

    };
    onChangeDayOfMonth = (value) => {
        //console.log("onChangeDayOfMonth1222");
        //console.log(value);
        this.setState({
            dayOfMonth: value,
            // dayOfWeek:'',
        })

    };
    handleCancel = () => this.setState({ previewVisible: false });
    handlePreview = file => {
        //console.log(file)
        this.setState({
            previewImage: file.thumbUrl,
            previewVisible: true
        });
    };
    handleRemove = (FileList) => {
        //console.log(FileList);
        var array = [...this.state.editfileList]; // make a separate copy of the array
        var index = array.indexOf(FileList.name)
        if (index !== -1) {
            array.splice(index, 1);
            //console.log(array)
            this.setState({ editfileList: array });
        }
    }
    handleUpload = (FileList) => {
        //---------------^^^^^----------------
        // This Is Equivalent To Your "const Img = Event.target.files[0]"
        // Here, Antd Is Giving You An Array Of Files, Just Like Event.target.files
        // But The Structure Is A Bit Different That The Original File
        // The Original File Is Located At The `originFileObj` Key Of Each Of This Files
        // So `event.target.files[0]` Is Actually FileList[0].originFileObj
        //console.log('fileList', FileList.fileList);

        this.setState({
            uploadFiles: FileList.fileList,
            fileList: FileList.fileList
        })

        // You Store Them In State, So That You Can Make A Http Req With Them Later

    };
    selectedNewUserDel(value, id) {
        if (id != null) {
            if (value !== -1) {

                valuesArrObjVisitor.filter(visitor3 => visitor3.id == id).map((item, key) => (

                    valuesArrObjVisitor.push(
                        {
                            "id": item.id,
                            "name": item.name,
                            "mobileNo": item.mobileNo,
                            "nic": item.nic,
                            "otherDetail": item.otherDetail,
                            "visitorType": item.visitorType,
                            "user": item.user,
                            "active": false
                        }
                    )

                ))
                valuesArrObjVisitor.splice(--value, 1);
                //console.log(valuesArrObjVisitor);
                this.setState({ visitors: valuesArrObjVisitor });

            }

        } else {
            if (value !== -1) {
                valuesArrObjVisitor.splice(--value, 1);
                this.setState({ visitors: valuesArrObjVisitor });
            }
        }



        //console.log(this.state.visitors)

    };
    selectedQuiDel(value, id) {

        if (id != null) {
            if (value !== -1) {

                valuesArrObj.filter(equipments2 => equipments2.id == id).map((item, key) => (

                    valuesArrObj.push(
                        {
                            "name": item.name,
                            "serialNo": item.serialNo,
                            "discription": item.discription,
                            "ActionType": item.actionType,
                            "qnty": item.qnty,
                            "active": false,
                            "id": item.id
                        }
                    )

                ))
                valuesArrObj.splice(--value, 1);
                //console.log(valuesArrObj);
                this.setState({ equipments: valuesArrObj });

            }

        } else {
            if (value !== -1) {

                valuesArrObj.splice(--value, 1);

                this.setState({ equipments: valuesArrObj });
            }
        }




        //console.log(this.state.equipments)

    };
    selectedInsDel(value, id) {
        if (id != null) {

            if (value !== -1) {
                valuesArrObjInst.filter(instruments3 => instruments3.id == id).map((item, key) => (

                    valuesArrObjInst.push(
                        {
                            "name": item.name,
                            "serialNo": item.serialNo,
                            "discription": item.discription,
                            "ActionType": item.actionType,
                            "qnty": item.qnty,
                            "active": false,
                            "id": item.id
                        }
                    )

                ))
                valuesArrObjInst.splice(--value, 1);
                //console.log(valuesArrObjInst);
                this.setState({ instruments: valuesArrObjInst });
            }
        } else {
            if (value !== -1) {
                valuesArrObjInst.splice(--value, 1);
                this.setState({ instruments: valuesArrObjInst });
            }
        }



        //console.log(this.state.instruments)

    };
    selectedInsVhe(value, id) {
        if (id != null) {
            if (value !== -1) {
                valuesArrObjVhe.filter(accessVehicles3 => accessVehicles3.id == id).map((item, key) => (

                    valuesArrObjVhe.push(
                        {
                            "vehicleNo": item.vehicleNo,
                            "vehicleType": item.vehicleType,
                            "active": false,
                            "id": item.id
                        }
                    )

                ))
                valuesArrObjVhe.splice(--value, 1);
                //console.log(valuesArrObjVhe);
                this.setState({ accessVehicles: valuesArrObjVhe });
            }
        } else {
            if (value !== -1) {
                valuesArrObjVhe.splice(--value, 1);
                this.setState({ accessVehicles: valuesArrObjVhe });
            }

        }



        //console.log(this.state.accessVehicles)

    };
    onChangeTeamMember = (value) => {

        //const {data, color, name} = _data;
        var arrayNew = []
        //console.log("onChangeTeamMember");
        //console.log(value);
        //console.log(valuesArrObjVisitor.filter(checkuser => checkuser?.user?.id == value));
        if (valuesArrObjVisitor.filter(checkuser => checkuser?.user?.id == value)[0] == null) {
            this.state.AllUsers.filter(allusernew => allusernew.id == value).map((item, key) => (
                valuesArrObjVisitor.push(
                    { "name": item.name, "isActive": item.status, "mobileNo": item.mobileNumber, "nic": item.nic, "company": 'dd', "visitorType": 'eee', "user": { "id": item.id }, "active": true }
                )
            ))


            //console.log("sss")
            this.setState({
                visitors: valuesArrObjVisitor,
                newUserSelectTo: ""
            })
            //console.log(valuesArrObjVisitor)
        } else {
            alert("This user already in")
        }


    };
    formItemChange = (event) => {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
        //console.log(obj)
    }

    handleChangeItmeName(e) {
        this.setState({ equ_itemName: e.target.value });
    }
    handleChangeSerialNum(e) {
        this.setState({ equ_sirialNum: e.target.value });
    }
    handleChangeActionType(e) {
        this.setState({ equ_actionType: e.target.value });
    }

    handleChangeDescription(e) {
        this.setState({ equ_description: e.target.value });
    }
    handleChangeQty(e) {
        this.setState({ equ_qty: e.target.value });
    }
    AllDataSubmit = async () => {
        var dataSet;
        if (this.state.sites != "") {
            if (this.state.recurrentStatus == false) {
                //console.log("AllDatasubmit");
                dataSet = {
                    "id": this.state.siteAccessId,
                    "referenceNo": this.state.referenceNo,
                    "workDescription": this.state.workDescription,
                    "files": this.state.editfileList,

                    "scheduleType": this.state.scheduleType,
                    "operationType": this.state.operationType,
                    "projectName": this.state.projectName,

                    "scopeOfWork": this.state.scopeOfWork,

                    "downTimeRequiredDate": this.state.downTimeRequiredDate,

                    "nameOfTeamLeader": this.state.nameOfTeamLeader,

                    "contactNoOfTeamLeader": this.state.contactNoOfTeamLeader,
                    "visitingPurpose": this.state.visitingPurpose,
                    "accessNeed": this.state.accessNeed,
                    "workArea": this.state.workArea,
                    "workType": this.state.workType,
                    "remarks": this.state.workRemarks,
                    "relatedTechnology": this.state.relatedTechnology,
                    "sites": this.state.sites,
                    "handler": this.state.handler,
                    "scheduleStartOn": '',
                    "scheduleEndOn": '',
                    "dayOfWeek": '',
                    "dayOfMonth": '',
                    "accessDate": this.state.accessDate,
                    "accessEndDate": this.state.accessEndDate,

                    "accessStartOn": '0000-00-00T' + this.state.accessStartOn + '.000+05:30',
                    "workDuration": (this.state.workDuration) * 60,
                    "visitors": this.state.visitors,
                    "equipments": this.state.equipments,
                    "instruments": this.state.instruments,
                    "accessVehicles": this.state.accessVehicles
                }
            }
            if (this.state.recurrentStatus == true) {
                if (this.state.scheduleType['id'] == 2) {
                    dataSet = {
                        "id": this.state.siteAccessId,
                        "referenceNo": this.state.referenceNo,
                        "workDescription": this.state.workDescription,
                        "files": this.state.editfileList,
                        "scheduleType": this.state.scheduleType,
                        "operationType": this.state.operationType,
                        "visitingPurpose": this.state.visitingPurpose,
                        "accessNeed": this.state.accessNeed,
                        "workArea": this.state.workArea,
                        "workType": this.state.workType,
                        "projectName": this.state.projectName,

                        "scopeOfWork": this.state.scopeOfWork,

                        "downTimeRequiredDate": this.state.downTimeRequiredDate,

                        "nameOfTeamLeader": this.state.nameOfTeamLeader,

                        "contactNoOfTeamLeader": this.state.contactNoOfTeamLeader,
                        "remarks": this.state.workRemarks,
                        "relatedTechnology": this.state.relatedTechnology,
                        "sites": this.state.sites,
                        "handler": this.state.handler,
                        "scheduleStartOn": this.state.scheduleStartOn,
                        "scheduleEndOn": this.state.scheduleEndOn,
                        "dayOfWeek": this.state.dayOfWeek,
                        "dayOfMonth": '',
                        "accessDate": '',
                        "accessEndDate": '',
                        "accessStartOn": '0000-00-00T' + this.state.accessStartOn + '.000+05:30',
                        "workDuration": (this.state.workDuration) * 60,
                        "visitors": this.state.visitors,
                        "equipments": this.state.equipments,
                        "instruments": this.state.instruments,
                        "accessVehicles": this.state.accessVehicles
                    }
                }
                if (this.state.scheduleType['id'] == 3) {
                    dataSet = {
                        "id": this.state.siteAccessId,
                        "referenceNo": this.state.referenceNo,
                        "workDescription": this.state.workDescription,
                        "files": this.state.editfileList,

                        "scheduleType": this.state.scheduleType,
                        "operationType": this.state.operationType,
                        "projectName": this.state.projectName,

                        "scopeOfWork": this.state.scopeOfWork,

                        "downTimeRequiredDate": this.state.downTimeRequiredDate,

                        "nameOfTeamLeader": this.state.nameOfTeamLeader,

                        "contactNoOfTeamLeader": this.state.contactNoOfTeamLeader,
                        "visitingPurpose": this.state.visitingPurpose,
                        "accessNeed": this.state.accessNeed,
                        "workArea": this.state.workArea,
                        "workType": this.state.workType,
                        "remarks": this.state.workRemarks,
                        "relatedTechnology": this.state.relatedTechnology,
                        "sites": this.state.sites,
                        "handler": this.state.handler,
                        "scheduleStartOn": this.state.scheduleStartOn,
                        "scheduleEndOn": this.state.scheduleEndOn,
                        "dayOfWeek": '',
                        "dayOfMonth": this.state.dayOfMonth,
                        "accessDate": '',
                        "accessEndDate": '',
                        "accessStartOn": '0000-00-00T' + this.state.accessStartOn + '.000+05:30',
                        "workDuration": (this.state.workDuration) * 60,
                        "visitors": this.state.visitors,
                        "equipments": this.state.equipments,
                        "instruments": this.state.instruments,
                        "accessVehicles": this.state.accessVehicles
                    }
                }


            }

            this.setState({
                alldataset: dataSet,
                submit_loading: true
            })

            // //console.log("alllll datttttaaa");
            //console.log(dataSet);

            var form = new FormData();
            form.append("accessPermitionData", JSON.stringify(dataSet));
            //console.log(this.state.uploadFiles)
            this.state.uploadFiles?.map((item, index) => {
                form.append('files', item.originFileObj);

            })
            var res = await siteAccessEdit(form);
            //console.log("siteAccessEdit");

            if (res.success) {
                //console.log("awaaa")
                const { history } = this.props;
                history.push("/site-access/list");
            }

        } else {

            alert('please complete required fields')
        }
        //console.log(dataSet);

    }
    handleSubmitNewUser(e) {
        if (this.validatorNewuser.allValid()) {

            valuesArrObjVisitor.push(
                { "name": this.state.newUserName, "mobileNo": this.state.newUserConNum, "nic": this.state.newUsernic, "company": this.state.newUserCompany, "user": null, "active": true }
            )
            document.getElementById("equipment_close").click()
            //console.log(valuesArrObjVisitor)
            this.setState({
                visitors: valuesArrObjVisitor,
                newUserName: "",
                newUserConNum: "",
                newUsernic: "",
                newUserCompany: "",
                // equ_description: "",
                // equ_qty: "",
            })

        } else {
            //console.log("dkfdkfd");
            this.validatorNewuser.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }


    }
    handleSubmit(e) {
        if (this.validatorequ.allValid()) {





            valuesArrObj.push(
                {
                    "name": this.state.equ_itemName,
                    "serialNo": this.state.equ_sirialNum,
                    "discription": this.state.equ_description,
                    "ActionType": this.state.equ_actionType,
                    "qnty": this.state.equ_qty,
                    "active": 1
                }
            )
            document.getElementById("equipment_close").click()

            //console.log(valuesArrObj)
            this.setState({
                equipments: valuesArrObj,
                equ_itemName: "",
                equ_sirialNum: "",
                equ_actionType: "",
                equ_description: "",
                equ_qty: "",
            })
        }
        else {
            this.validatorequ.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }

        //  e.preventDefault();
    }
    handleChangeInsItmeName(e) {
        this.setState({ ins_itemName: e.target.value });
    }
    handleChangeInsSerialNum(e) {
        this.setState({ ins_sirialNum: e.target.value });
    }
    handleChangeInsActionType(e) {
        this.setState({ ins_actionType: e.target.value });
    }

    handleChangeInsDescription(e) {
        this.setState({ ins_description: e.target.value });
    }
    handleChangetUserName(e) {
        this.setState({ newUserName: e.target.value });
    }
    handleChangetUserCompany(e) {
        this.setState({ newUserCompany: e.target.value });
    }
    handleChangetUserContactNumber(e) {
        this.setState({ newUserConNum: e.target.value });
    }
    handleChangetUserNic(e) {
        this.setState({ newUsernic: e.target.value });
    }
    handleChangeInsQty(e) {
        this.setState({ ins_qty: e.target.value });
    }
    handleInsSubmit(e) {
        if (this.validatorins.allValid()) {
            valuesArrObjInst.push(
                {
                    "name": this.state.ins_itemName,
                    "serialNo": this.state.ins_sirialNum,
                    "discription": this.state.ins_description,
                    "ActionType": this.state.ins_actionType,
                    "qnty": this.state.ins_qty,
                    "active": 1
                }
            )
            document.getElementById("instrument_close").click()
            //console.log(valuesArrObjInst)
            this.setState({
                instruments: valuesArrObjInst,
                ins_itemName: "",
                ins_sirialNum: "",
                ins_actionType: "",
                ins_description: "",
                ins_qty: "",
            })

        } else {
            this.validatorins.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }

        //  e.preventDefault();
    }
    handleChangeVheNo(e) {
        this.setState({ vhe_no: e.target.value });
    }
    handleChangeVheType(e) {
        this.setState({ vhe_type: e.target.value });
    }

    handleVheSubmit(e) {
        if (this.validator.allValid()) {
            valuesArrObjVhe.push({
                "vehicleNo": this.state.vhe_no,
                "vehicleType": this.state.vhe_type,
                "active": 1
            })
            document.getElementById("vehicle_close").click()
            //console.log(valuesArrObjVhe)

            this.setState({
                accessVehicles: valuesArrObjVhe,
                vhe_no: "",
                vhe_type: "",
            })
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }

        // e.preventDefault();
    }
    handleChangeRefNo(e) {
        ////console.log(e.target.value)
        this.setState({ referenceNo: e.target.value });
    }

    handleRemarks(e) {
        //console.log(e.target.value)
        this.setState({ workRemarks: e.target.value });
    }
    handleChangeWorkDes(e) {
        //console.log(e.target.value)
        this.setState({ workDescription: e.target.value });
    }
    handleContactNoofTeamLeader(e) {
        //console.log(e.target.value)
        this.setState({ contactNoOfTeamLeader: e.target.value });
    }
    handleNameofTeamLeader(e) {
        //console.log(e.target.value)
        this.setState({ nameOfTeamLeader: e.target.value });
    }
    handleScopeofWork(e) {
        //console.log(e.target.value)
        this.setState({ scopeOfWork: e.target.value });
    }
    handleProjectName(e) {
        //console.log(e.target.value)
        this.setState({ projectName: e.target.value });
    }
    handleChangeDuration(e) {
        //console.log(e.target.value)
        this.setState({ workDuration: e.target.value });
    }
    onImportExcel = event => {
        const { files } = event.target;
        if (files.length === 1) {
            //console.log(files);
            // Process a file if we have exactly one
            importExcel(
                files[0],
                // Not sure what you want to do with the data, so let's just log it
                (Name, ContactNumber, Nic, Company) => {

                    if (Name) {
                        valuesArrObjVisitor.push(
                            { "name": Name, "mobileNo": ContactNumber, "nic": Nic, "user": null, "company": Company, "active": true }
                        )
                        // document.getElementById("equipment_close").click()
                        //console.log(valuesArrObjVisitor)
                        this.setState({
                            visitors: valuesArrObjVisitor,

                        })
                    }

                },
            );
        }
    };


    render() {
        const { Option } = Select;
        var today = new Date();
        //console.log("slpololll");
        //console.log(today.getUTCDate());
        const dataSource = this.state.equipments;

        const columns = [
            {
                title: 'Name',
                dataIndex: 'name',
                //  key: 'name',
            },
            {
                title: 'Serial Number',
                dataIndex: 'serialNo',
                // key: 'serialNo',
            },
            {
                title: 'Action Type',
                dataIndex: 'ActionType',
                // key: 'ActionType',
            },
            {
                title: 'Description',
                dataIndex: 'discription',
                // key: 'discription',
            },
            {
                title: 'Qty',
                dataIndex: 'qnty',
                // key: 'qnty',
            }
        ];


        // function onSearch(val) {
        //     //console.log('search:', val);
        //   }

        function MyFormComponent() {
            const [form] = Form.useForm();

            const submitForm = ({ name, favoriteColor }) => {
                //console.log(name, favoriteColor);
                form.resetFields();
            };

            return (
                <Form
                    form={form}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 12 }}
                    onFinish={submitForm}
                >
                    <Form.Item name="name" label="What is your name?">
                        <Input />
                    </Form.Item>
                    <Form.Item name="favoriteColor" label="What is your favorite color?">
                        <Input />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 6, span: 12 }}>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            );
        }
        return (
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="page-title-box">
                            <div class="row">
                                <div class="col">
                                    <h4 class="page-title">New  Site Access</h4>
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a href="javascript:void(0);">Site Access</a></li>
                                        <li class="breadcrumb-item"><a href="javascript:void(0);">Create</a></li>
                                        

                                    </ol>
                                </div>
                                <div class="col-auto align-self-center">
                                    <a href="#" class="btn btn-sm btn-outline-primary" id="Dash_Date">
                                        <span class="day-name" id="Day_Name">Today:</span>&nbsp;
                                        <span class="" id="Select_date">{new Date().toUTCString().slice(5, 16)}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar align-self-center icon-xs ms-1"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Create Site Access Request</h4>
                            </div>
                            <div className="card-body">
                                <div className='row'>
                                    <div className="col-md-6">
                                        <label className="form-label" for="users">
                                            Add Site<x style={{ color: "red" }}>*</x>
                                        </label>
                                        {this.state.EditsiteArry != null ? (<Select
                                            showSearch
                                            onChange={this.onChangeSite}
                                            defaultValue={this.state.EditsiteArry}
                                            loading={this.state.allSite_loading}

                                            style={{ width: "100%" }}
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                            }

                                        >

                                            {this.state.allSite.map((item, index) => {
                                                return <Option value={item.id}>{item.siteName}</Option>;
                                            })}
                                        </Select>) : ("")}


                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label" for="depot">
                                            Group<x style={{ color: "red" }}>*</x>
                                        </label>
                                        {this.state.selectedGroupName != "" ? (<div><Form.Item required tooltip="This is a required field">
                                            <Input disabled placeholder="Group" value={this.state.selectedGroupName} />
                                        </Form.Item></div>) : ("")}


                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label" for="users">
                                            Handler<x style={{ color: "red" }}>*</x>
                                        </label>
                                        {this.state.haddalerArry != null ? (<Select
                                            showSearch
                                            onChange={this.onChangeHandler}
                                            defaultValue={this.state.haddalerArry}
                                            style={{ width: "100%" }}
                                            placeholder="Search to Select"
                                            optionFilterProp="children"

                                        >
                                            {this.state.AllHandlersBySite.map((item, index) => {
                                                return <Option value={item.id}>{item.name} ({item.mobileNumber}) </Option>;
                                            })}
                                        </Select>) : ("")}


                                    </div>
                                </div>
                                <div className='row'>
                                    <br></br>

                                    <div className="col-md-12">
                                        <br></br>

                                        <div className="card">
                                            <div className="card-body">
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <div className='row'>

                                                            <div className='col-md-10'>
                                                                <label className="form-label" for="depot">
                                                                    Operation Type
                                                                </label>
                                                                {this.state.editEoperationType != null ? (<Select
                                                                    style={{ width: "100%" }}
                                                                    showSearch
                                                                    defaultValue={this.state.editEoperationType}
                                                                    placeholder="Select a person"
                                                                    optionFilterProp="children"
                                                                    onChange={this.onChangeOperationType}
                                                                    //onSearch={onSearch}
                                                                    filterOption={(input, option) =>
                                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                >
                                                                    <Option value="1">Operation</Option>
                                                                    <Option value="2">Project</Option>

                                                                </Select>) : ("")}

                                                            </div>


                                                            {/* <div className='col-md-2'>
                                                                <label className="form-label" for="depot">
                                                                    Recurrent
                                                                </label>
                                                                <br></br>
                                                                {this.state.recurrentStatus ? (<div><Switch defaultChecked onChange={this.OnChangeRecurrent} /></div>) : (<Switch onChange={this.OnChangeRecurrent} />)}

                                                            </div> */}
                                                        </div>




                                                    </div>
                                                    {this.state.selectOpararionType == 2 ? (

                                                        <div className='row'>
                                                            <br></br>
                                                            <div className='col-md-6'>
                                                                <label className="form-label" for="depot">
                                                                    Project Name
                                                                </label>
                                                                <Form.Item required tooltip="This is a required field">
                                                                    <Input placeholder="Project Name " value={this.state.projectName} onChange={this.handleProjectName} />
                                                                </Form.Item>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label className="form-label" for="depot">
                                                                    Scope of Work
                                                                </label>
                                                                <Form.Item required tooltip="This is a required field">
                                                                    <Input placeholder="Scope of Work" value={this.state.scopeOfWork} onChange={this.handleScopeofWork} />
                                                                </Form.Item>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label className="form-label" for="downTimeRequiredDate">
                                                                    Down Time Required Date
                                                                </label>
                                                                {/* <DatePicker
                                                                    defaultValue={moment()}
                                                                    style={{ width: "100%" }}
                                                                    onChange={this.onChangeDownTimeRequiredDate}
                                                                //onChange={this.onChangeScheduleStartOn}
                                                                /> */}

                                                                {this.state.downTimeRequiredDate != null ? (<DatePicker
                                                                    // defaultValue={moment(this.state.downTimeRequiredDate)}this.state.siteOnAirDate!=''?(moment(this.state.siteOnAirDate)):("")
                                                                    defaultValue={this.state.downTimeRequiredDate != '' ? (moment(this.state.downTimeRequiredDate)) : ("")}
                                                                    style={{ width: "100%" }}
                                                                    onChange={this.onChangeDownTimeRequiredDate}
                                                                />) : ("")}
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label className="form-label" for="depot">
                                                                    Name of Team Leader
                                                                </label>
                                                                <Form.Item required tooltip="This is a required field">
                                                                    <Input placeholder="Name of Team Leader" value={this.state.nameOfTeamLeader} onChange={this.handleNameofTeamLeader} />
                                                                </Form.Item>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label className="form-label" for="depot">
                                                                    Contact No of Team Leader
                                                                </label>
                                                                <Form.Item required tooltip="This is a required field">
                                                                    <Input placeholder="Contact No of Team Leader" value={this.state.contactNoOfTeamLeader} onChange={this.handleContactNoofTeamLeader} />
                                                                </Form.Item>
                                                            </div>
                                                        </div>
                                                    ) : ('')}
                                                    {this.state.recurrentStatus ? (<div className="col-md-6">


                                                        <label className="form-label" for="depot">
                                                            Schedule Type
                                                        </label>
                                                        {this.state.editScheduleType != null ? (<Select
                                                            style={{ width: "100%" }}
                                                            showSearch
                                                            defaultValue={this.state.editScheduleType?.name}
                                                            placeholder="Select a person"
                                                            optionFilterProp="children"
                                                            onChange={this.onChangeScheduleType}
                                                            //onSearch={onSearch}
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                        >

                                                            <Option value="2">Weekly</Option>
                                                            <Option value="3">Monthly</Option>

                                                        </Select>) : ("")}




                                                    </div>) : ("")}

                                                </div>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className='row'>
                                    {this.state.recurrentStatus ? ('') : (<div className="col-md-6" style={{ marginBottom: 22 }}>
                                        <label className="form-label" for="depot">
                                            Permission Start Date<x style={{ color: "red" }}>*</x> 
                                        </label>
                                        {this.state.editAccessDate != null ? (<DatePicker
                                            defaultValue={moment(this.state.editAccessDate)}
                                            style={{ width: "100%" }}
                                            onChange={this.onChangeAccessDate}
                                        />) : ("")}

                                    </div>)}


                                    {this.state.recurrentStatus ? (<div>
                                        {this.state.scheduleType['id'] == 2 || this.state.scheduleType['id'] == 1 ? (<div className="col-md-6" style={{ marginBottom: 22 }}>
                                            <label className="form-label" for="depot">
                                                Day of Week
                                            </label>
                                            {this.state.editDayOfWeek != null ? (<Select
                                                style={{ width: "100%" }}
                                                showSearch
                                                defaultValue={(this.state.editDayOfWeek).toString()}
                                                placeholder="Select a person"
                                                optionFilterProp="children"
                                                onChange={this.onChangeDayOfWeek}
                                                //onSearch={onSearch}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value="0">Sunday</Option>
                                                <Option value="1">Monday</Option>
                                                <Option value="2">Tuesday</Option>
                                                <Option value="3">Wednesday</Option>
                                                <Option value='4'>Thursday</Option>
                                                <Option value="5">Friday</Option>
                                                <Option value="6">Saturday</Option>

                                            </Select>) : ('')}

                                        </div>) : ('')}
                                    </div>) : ('')}

                                    {this.state.recurrentStatus ? (<div>
                                        {this.state.scheduleType['id'] == 3 ? (<div className="col-md-6" style={{ marginBottom: 22 }}>
                                            <label className="form-label" for="depot">
                                                Day of Month
                                            </label>
                                            {this.state.editDayOfMonth != null ? (<Select
                                                style={{ width: "100%" }}
                                                showSearch
                                                defaultValue={(this.state.editDayOfMonth).toString()}
                                                placeholder="Select a person"
                                                optionFilterProp="children"
                                                onChange={this.onChangeDayOfMonth}
                                                //onSearch={onSearch}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value="1">1</Option>
                                                <Option value="2">2</Option>
                                                <Option value="3">3</Option>
                                                <Option value="4">4</Option>
                                                <Option value="5">5</Option>
                                                <Option value="6">6</Option>
                                                <Option value="7">7</Option>
                                                <Option value="8">8</Option>
                                                <Option value="9">9</Option>
                                                <Option value="10">10</Option>
                                                <Option value="11">11</Option>
                                                <Option value="12">12</Option>
                                                <Option value="13">13</Option>
                                                <Option value="14">14</Option>
                                                <Option value="15">15</Option>
                                                <Option value="16">16</Option>
                                                <Option value="17">17</Option>
                                                <Option value="18">18</Option>
                                                <Option value="19">19</Option>
                                                <Option value="21">21</Option>
                                                <Option value="22">22</Option>
                                                <Option value="23">23</Option>
                                                <Option value="24">24</Option>
                                                <Option value="25">25</Option>
                                                <Option value="26">26</Option>
                                                <Option value="28">28</Option>
                                                <Option value="29">29</Option>
                                                <Option value="30">30</Option>
                                                <Option value="31">31</Option>

                                            </Select>) : ("")}

                                        </div>) : ('')}
                                    </div>) : ('')}


                                    {this.state.recurrentStatus ? (<div className="col-md-6" style={{ marginBottom: 22 }}>
                                        <label className="form-label" for="depot">
                                            Schedule Start Date
                                        </label>
                                        {this.state.editScheduleStartOn != null ? (<DatePicker
                                            defaultValue={moment(this.state.editScheduleStartOn)}
                                            style={{ width: "100%" }}
                                            onChange={this.onChangeScheduleStartOn}
                                        />) : ("")}

                                    </div>) : ("")}
                                    {this.state.recurrentStatus ? (<div className="col-md-6" style={{ marginBottom: 22 }}>
                                        <label className="form-label" for="depot">
                                            Schedule End date
                                        </label>
                                        {this.state.editScheduleEndOn != null ? (<DatePicker
                                            defaultValue={moment(this.state.editScheduleEndOn)}
                                            style={{ width: "100%" }}
                                            onChange={this.onChangeScheduleEndOn}
                                        />) : ("")}

                                    </div>) : ("")}
                                    <div className="col-md-6" style={{ marginBottom: 22 }}>
                                        <label className="form-label" for="depot">
                                            Start Time 
                                        </label>
                                        {this.state.editAccessStartOn != null ? (<TimePicker style={{ width: "100%" }} defaultValue={moment((this.state.editAccessStartOn).toString(), format)} onChange={this.onChangeAccessStartOn} format={format} />) : ("")}

                                    </div>


                                    {this.state.recurrentStatus ? ('') : (<div className="col-md-6" style={{ marginBottom: 22 }}>
                                        <label className="form-label" for="depot">
                                            Permission End Date <x style={{ color: "red" }}>*</x>
                                        </label>
                                        {this.state.editAccessEndDate != null ? (<DatePicker
                                            defaultValue={moment(this.state.editAccessEndDate)}
                                            style={{ width: "100%" }}
                                            onChange={this.onChangeAccessEndDate}
                                        />) : ("")}
                                        {/* <p style={{ color: "#f5325c" }}>{this.validatorall.message('EndDate', this.state.accessEndDate, 'required')}</p> */}


                                    </div>)}

                                    {/* <div className="col-md-6" style={{ marginBottom: 0 }}>
                                        <label className="form-label" for="depot">
                                            Duration (Hours)
                                        </label>
                                        <Form.Item >
                                            <Input placeholder="Duration" value={this.state.workDuration} id="duration" onChange={this.handleChangeDuration} />

                                        </Form.Item>

                                    </div> */}




                                    {/* <div className="col-md-10">


                                        <label className="form-label" for="depot">
                                            Add Team Members
                                        </label>
                                        <Select
                                            showSearch
                                            style={{ width: "100%" }}
                                            defaultValue={this.state.newUserSelectTo}
                                            allowClear
                                            placeholder="Select a person"
                                            optionFilterProp="children"
                                            onChange={this.onChangeTeamMember}
                                        //onSearch={onSearch}

                                        >
                                            {this.state.AllUsers.map((item, index) => {
                                                return <Option value={item.id}>{item.name}-{item.mobileNumber}</Option>;
                                            })}

                                        </Select>



                                    </div> */}

                                    <div className="col-md-9">
                                        <label className="form-label" for="depot">
                                            Add Team Members <x style={{ color: "red" }}>*</x>
                                        </label>
                                        <Popup

                                            trigger={
                                                <Button block style={{ textAlign: "end" }} >
                                                    <PlusCircleOutlined /> <b style={{ color: "#40a9ff" }}>New User</b>
                                                </Button>
                                            }
                                            open={this.state.isOpen}
                                            modal>
                                            {close => (<div className="row" >
                                                <div className="col-lg-12">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h4 className="card-title">New User</h4>
                                                        </div>
                                                        <div className="card-body">
                                                            <form>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" className="form-control" name="user_Name" value={this.state.newUserName} aria-describedby="emailHelp" placeholder="User Name" onChange={this.handleChangetUserName} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validatorNewuser.message('User Name', this.state.newUserName, 'required')}</p>
                                                                </div>


                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.newUserConNum} className="form-control" name="user_contact_number" placeholder="Contact Number" onChange={this.handleChangetUserContactNumber} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validatorNewuser.message('Contact Number', this.state.newUserConNum, 'required')}</p>

                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="number" value={this.state.newUsernic} className="form-control" name="user_nic" placeholder="NIC" onChange={this.handleChangetUserNic} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validatorNewuser.message('NIC', this.state.newUsernic, 'required')}</p>
                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.newUserCompany} className="form-control" name="user_com" placeholder="Company" onChange={this.handleChangetUserCompany} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validatorNewuser.message('Company', this.state.newUserCompany, 'required')}</p>
                                                                </div>




                                                            </form>




                                                            <div className='row' style={{ justifyContent: "end" }}>
                                                                <div class='col-md-2' style={{ width: '10.66667%' }}>   <button className="btn btn-primary" onClick={() => this.handleSubmitNewUser()}>Submit</button></div>
                                                                <div class='col-md-2' style={{ width: '10.66667%' }}>
                                                                    <button className="btn btn-primary" id="equipment_close" onClick={close}>Close</button>

                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            )}
                                        </Popup>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className='row'>
                                            <label className="form-label" for="depot">
                                                Upload Team Members List(.xlsx, .xls)
                                            </label>

                                        </div>
                                        <div className='row'>
                                            <Button className="upload-wrap" style={{ textAlign: "left" }}>
                                                {/* <UploadOutlined/> */}
                                                <input style={{ margin: -9 }} className="file-uploader" type="file" accept=".xlsx, .xls" onChange={this.onImportExcel} />

                                            </Button>
                                            {/* <p className="upload-tip">Supports files in .xlsx, .xls format</p> */}

                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        {this.state.visitors[0] == null ? (<div className='row' style={{ textAlign: "center", justifyContent: 'center', textAlign: 'center', background: '#f1efec', margin: 8, display: "inherit" }}>
                                            <h5> Not Found !</h5>

                                        </div>) : (<div className='row' style={{ display: "contents" }}>
                                            <br></br>
                                            <table style={{ border: "1px solid black", width: "100%", fontSize: 11 }}>
                                                <thead>
                                                    <tr style={{ border: "1px solid black" }}>
                                                        <th style={{ border: "1px solid black" }}>#</th>
                                                        <th style={{ border: "1px solid black" }}>Name</th>
                                                        <th style={{ border: "1px solid black" }}>Contact Number</th>
                                                        <th style={{ border: "1px solid black" }}>NIC</th>
                                                        <th style={{ border: "1px solid black" }}>Company</th>

                                                        <th style={{ border: "1px solid black", width: "50px" }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.visitors.filter(visitors3 => visitors3.active == true).map((item, key) => (
                                                        <tr style={{ border: "1px solid black" }}>
                                                            <td style={{ border: "1px solid black" }}>{++key}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.name}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.mobileNo}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.nic}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.company}</td>

                                                            <td style={{ border: "1px solid black" }} > <Button block style={{ textAlign: "end" }} onClick={() => this.selectedNewUserDel(key, item?.id)}>
                                                                <DeleteOutlined />
                                                            </Button></td>
                                                        </tr>
                                                    ))}




                                                </tbody>
                                            </table>

                                        </div>)}
                                    </div>
                                    <div className="col-md-12">
                                        <br></br>

                                        <label className="form-label" for="depot">
                                            Equipments
                                        </label>



                                        <Popup
                                            open={this.state.isOpen}
                                            trigger={
                                                <Button block style={{ textAlign: "end" }} >
                                                    <PlusCircleOutlined /> <b style={{ color: "#40a9ff" }}>Add Equipments</b>
                                                </Button>
                                            } modal>
                                            {close => (<div className="row" >
                                                <div className="col-lg-12">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h4 className="card-title">Add Equipment</h4>
                                                        </div>
                                                        <div className="card-body">
                                                            <form>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" className="form-control" name="Item_Name" value={this.state.equ_itemName} aria-describedby="emailHelp" placeholder="Item Name" onChange={this.handleChangeItmeName} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validatorequ.message('name', this.state.equ_itemName, 'required')}</p>
                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.equ_sirialNum} className="form-control" name="Serial_Number" placeholder="Enter Serial Number" onChange={this.handleChangeSerialNum} />
                                                                    {/* <p style={{ color: "#f5325c" }}>{this.validatorequ.message('Serial Number', this.state.equ_sirialNum, 'required')}</p> */}
                                                                </div>

                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.equ_actionType} className="form-control" name="Action_Type" placeholder="Enter Action Type" onChange={this.handleChangeActionType} />
                                                                    {/* <p style={{ color: "#f5325c" }}>{this.validatorequ.message('Action Type', this.state.equ_actionType, 'required')}</p> */}
                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.equ_description} className="form-control" name="Description" placeholder="Enter Description" onChange={this.handleChangeDescription} />
                                                                    {/* <p style={{ color: "#f5325c" }}>{this.validatorequ.message('description', this.state.equ_description, 'required')}</p> */}
                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="number" value={this.state.equ_qty} className="form-control" name="Quantity" placeholder="Enter Quantity" onChange={this.handleChangeQty} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validatorequ.message('Quantity', this.state.equ_qty, 'required')}</p>
                                                                </div>




                                                            </form>
                                                            <div className='row' style={{ justifyContent: "end" }}>
                                                                <div class='col-md-2' style={{ width: '10.66667%' }}>   <button className="btn btn-primary" onClick={() => this.handleSubmit()}>Submit</button></div>
                                                                <div class='col-md-2' style={{ width: '10.66667%' }}>
                                                                    <button className="btn btn-primary" id="equipment_close" onClick={close}>Close</button>

                                                                </div>

                                                            </div>
                                                            <div className='row'>

                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            )}
                                        </Popup>
                                        <div className='row'>

                                        </div>
                                        {this.state.equipments == "" ? (<div className='row' style={{ textAlign: "center", justifyContent: 'center', textAlign: 'center', background: '#f1efec', margin: 8, display: "inherit" }}>
                                            <h5> Not Found !</h5>

                                        </div>) : (<div className='row' style={{ display: "contents" }}>
                                            <br></br>
                                            <table style={{ border: "1px solid black", width: "100%", fontSize: 11 }}>
                                                <thead>
                                                    <tr style={{ border: "1px solid black" }}>
                                                        <th style={{ border: "1px solid black" }}>#</th>
                                                        <th style={{ border: "1px solid black" }}>Name</th>
                                                        <th style={{ border: "1px solid black" }}>Serial Number</th>
                                                        <th style={{ border: "1px solid black" }}>Action Type</th>
                                                        <th style={{ border: "1px solid black" }}>Description</th>
                                                        <th style={{ border: "1px solid black" }}>Quantity</th>
                                                        <th style={{ border: "1px solid black", width: "50px" }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.equipments.filter(equipments2 => equipments2.active == true).map((item, key) => (
                                                        <tr style={{ border: "1px solid black" }}>
                                                            <td style={{ border: "1px solid black" }}>{++key}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.name}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.serialNo}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.ActionType}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.discription}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.qnty}</td>
                                                            <td style={{ border: "1px solid black" }} > <Button block style={{ textAlign: "end" }} onClick={() => this.selectedQuiDel(key, item?.id)}>
                                                                <DeleteOutlined />
                                                            </Button></td>
                                                        </tr>
                                                    ))}



                                                </tbody>
                                            </table>

                                        </div>)}


                                    </div>
                                    <div className="col-md-12">
                                        <br></br>
                                        <label className="form-label" for="depot">
                                            Instrument
                                        </label>



                                        <Popup trigger={
                                            <Button block style={{ textAlign: "end" }} >
                                                <PlusCircleOutlined /> <b style={{ color: "#40a9ff" }}>Add Instrument</b>
                                            </Button>
                                        } modal>
                                            {close => (<div className="row">
                                                <div className="col-lg-12">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h4 className="card-title">Add Instrument</h4>
                                                        </div>
                                                        <div className="card-body">
                                                            <form>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" className="form-control" name="ins_Item_Name" value={this.state.ins_itemName} aria-describedby="emailHelp" placeholder="Item Name" onChange={this.handleChangeInsItmeName} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validatorins.message('Item name', this.state.ins_itemName, 'required')}</p>
                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.ins_sirialNum} className="form-control" name="ins_Serial_Number" placeholder="Enter Serial Number" onChange={this.handleChangeInsSerialNum} />
                                                                    {/* <p style={{ color: "#f5325c" }}>{this.validatorins.message('Serial Number', this.state.ins_sirialNum, 'required')}</p> */}
                                                                </div>

                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.ins_actionType} className="form-control" name="ins_Action_Type" placeholder="Enter Action Type" onChange={this.handleChangeInsActionType} />
                                                                    {/* <p style={{ color: "#f5325c" }}>{this.validatorins.message('Action Type', this.state.ins_actionType, 'required')}</p> */}
                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.ins_description} className="form-control" name="ins_Description" placeholder="Enter Description" onChange={this.handleChangeInsDescription} />
                                                                    {/* <p style={{ color: "#f5325c" }}>{this.validatorins.message('description', this.state.ins_description, 'required')}</p> */}
                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="number" value={this.state.ins_qty} className="form-control" name="ins_Quantity" placeholder="Enter Quantity" onChange={this.handleChangeInsQty} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validatorins.message('Quantity', this.state.ins_qty, 'required')}</p>
                                                                </div>





                                                            </form>
                                                            {/* <button className="btn btn-primary" onClick={() => this.handleInsSubmit()}>Submit</button> */}

                                                            <div className='row' style={{ justifyContent: "end" }} >
                                                                <div class='col-md-2' style={{ width: '10.66667%' }}>
                                                                    <button className="btn btn-primary" onClick={() => this.handleInsSubmit()}>Submit</button>
                                                                </div>
                                                                <div class='col-md-2' style={{ width: '10.66667%' }}>
                                                                    <button className="btn btn-primary" id="instrument_close" onClick={close}>Close</button>

                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            )}
                                        </Popup>
                                        <div className='row'>

                                        </div>
                                        {this.state.instruments == "" ? (<div className='row' style={{ textAlign: "center", justifyContent: 'center', textAlign: 'center', background: '#f1efec', margin: 8, display: "inherit" }}>
                                            <h5> Not Found !</h5>

                                        </div>) : (<div className='row' style={{ display: "contents" }}>
                                            <br></br>
                                            <table style={{ border: "1px solid black", width: "100%", fontSize: 11 }}>
                                                <thead>
                                                    <tr style={{ border: "1px solid black" }}>
                                                        <th style={{ border: "1px solid black" }}>#</th>
                                                        <th style={{ border: "1px solid black" }}>Name</th>
                                                        <th style={{ border: "1px solid black" }}>Serial Number</th>
                                                        <th style={{ border: "1px solid black" }}>Action Type</th>
                                                        <th style={{ border: "1px solid black" }}>Description</th>
                                                        <th style={{ border: "1px solid black" }}>Quantity</th>
                                                        <th style={{ border: "1px solid black", width: "50px" }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.instruments.filter(instruments2 => instruments2.active == true).map((item, key) => (
                                                        <tr style={{ border: "1px solid black" }}>
                                                            <td style={{ border: "1px solid black" }}>{++key}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.name}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.serialNo}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.ActionType}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.discription}</td>
                                                            <td style={{ border: "1px solid black" }}>{item.qnty}</td>
                                                            <td style={{ border: "1px solid black" }} > <Button block style={{ textAlign: "end" }} onClick={() => this.selectedInsDel(key, item?.id)}>
                                                                <DeleteOutlined />
                                                            </Button></td>
                                                        </tr>
                                                    ))}



                                                </tbody>
                                            </table>

                                        </div>)}
                                    </div>




                                    <div className="col-md-12">
                                        <br></br>
                                        <label className="form-label" for="depot">
                                            Vehicles
                                        </label>



                                        <Popup trigger={
                                            <Button block style={{ textAlign: "end" }} >
                                                <PlusCircleOutlined /> <b style={{ color: "#40a9ff" }}>Add Vehicle</b>
                                            </Button>
                                        } modal>
                                            {close => (<div className="row">
                                                <div className="col-lg-12">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h4 className="card-title">Add Vehicle</h4>
                                                        </div>
                                                        <div className="card-body">
                                                            <form>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" className="form-control" name="Vehicle_No" value={this.state.vhe_no} aria-describedby="emailHelp" placeholder="Vehicle No" onChange={this.handleChangeVheNo} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Vehicle No', this.state.vhe_no, 'required')}</p>
                                                                </div>
                                                                <div className="mb-3">

                                                                    <input autoComplete="off" type="text" value={this.state.vhe_type} className="form-control" name="Vehicle type" placeholder="Vehicle type" onChange={this.handleChangeVheType} />
                                                                    <p style={{ color: "#f5325c" }}>{this.validator.message('Vehicle type', this.state.vhe_type, 'required')}</p>
                                                                </div>






                                                            </form>
                                                            {/* <button className="btn btn-primary" onClick={() => this.handleVheSubmit()}>Submit</button> */}
                                                            <div className='row' style={{ justifyContent: "end" }}>
                                                                <div class='col-md-2' style={{ width: '10.66667%' }}>
                                                                    <button className="btn btn-primary" onClick={() => this.handleVheSubmit()}>Submit</button>
                                                                </div>
                                                                <div class='col-md-2' style={{ width: '10.66667%' }}>
                                                                    <button className="btn btn-primary" id="vehicle_close" onClick={close}>Close</button>

                                                                </div>

                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            )}
                                        </Popup>
                                        <div className='row'>

                                        </div>
                                        {this.state.accessVehicles == "" ? (
                                            <div className='row' style={{ textAlign: "center", justifyContent: 'center', textAlign: 'center', background: '#f1efec', margin: 8, display: "inherit" }}>
                                                <h5> Not Found !</h5>

                                            </div>) : (<div className='row' style={{ display: "contents" }}>
                                                <br></br>
                                                <table style={{ border: "1px solid #b3aaaa", width: "100%", fontSize: 11 }}>
                                                    <thead>
                                                        <tr style={{ border: "1px solid #b3aaaa" }}>
                                                            <th style={{ border: "1px solid #b3aaaa" }}>#</th>
                                                            <th style={{ border: "1px solid #b3aaaa" }}>Vehicle No</th>
                                                            <th style={{ border: "1px solid #b3aaaa" }}>Vehicle Type</th>

                                                            <th style={{ border: "1px solid #b3aaaa", width: "50px" }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.accessVehicles.filter(Vehicles => Vehicles.active == true).map((item, key) => (
                                                            <tr style={{ border: "1px solid #b3aaaa" }}>
                                                                <td style={{ border: "1px solid #b3aaaa" }}>{++key}</td>
                                                                <td style={{ border: "1px solid #b3aaaa" }}>{item.vehicleNo}</td>
                                                                <td style={{ border: "1px solid #b3aaaa" }}>{item.vehicleType}</td>

                                                                <td style={{ border: "1px solid black" }} > <Button block style={{ textAlign: "end" }} onClick={() => this.selectedInsVhe(key, item?.id)}>
                                                                    <DeleteOutlined />
                                                                </Button></td>
                                                            </tr>
                                                        ))}



                                                    </tbody>
                                                </table>

                                            </div>)}
                                        <br></br>
                                    </div>
                                    <div className='row' style={{ paddingBottom: 12 }}>

                                        <div className="col-md-6" style={{ marginBottom: 0 }}>
                                            <br></br>


                                            <Upload
                                                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                                listType=""
                                                multiple={true}
                                                fileList={[...this.state.fileList]}
                                                //defaultFileList={this.state.fileList}
                                                //   onPreview={this.handlePreview}
                                                onRemove={this.handleRemove}
                                                onChange={this.handleUpload}
                                                beforeUpload={() => false} // Return False So That Antd Doesn't Upload The Picture Right Away
                                            >
                                                <Button icon={<UploadOutlined />}>Upload the relevant documents</Button>
                                            </Upload>


                                        </div>

                                    </div>
                                    <Modal
                                        visible={this.state.previewVisible}
                                        footer={null}
                                        onCancel={this.handleCancel}
                                    >
                                        <img alt="example" style={{ width: "100%" }} src={this.state.previewImage} />
                                    </Modal>
                                    <br></br>
                                    {
                                        this.state.selectedGroupId == 1 ? (<div className="col-md-6">


                                            <label className="form-label" for="depot">
                                                Visiting Purpose
                                            </label>
                                            <Select
                                                //showSearch
                                                onChange={this.onChangeVisitingPurpose}
                                                defaultValue={this.state.visitingPurpose.id}
                                                style={{ width: "100%" }}
                                                placeholder="Search to Select"
                                                optionFilterProp="children"

                                            >
                                                {this.state.SiteAccessBaseDataVisitingPurposes.map((item, index) => {
                                                    return <Option value={item.id}>{item.name} </Option>;
                                                })}
                                            </Select>

                                        </div>) : ('')
                                    }
                                    {this.state.selectedGroupId == 1 || this.state.selectedGroupId == 10 ? (<div className="col-md-6" style={{ marginBottom: 0 }}>
                                        <label className="form-label" for="depot">
                                            Reference No
                                        </label>
                                        <Form.Item required tooltip="This is a required field">
                                            <Input placeholder="Reference No" id="ref_no" value={this.state.referenceNo} onChange={this.handleChangeRefNo} />
                                        </Form.Item>

                                    </div>) : ('')}
                                    {this.state.selectedGroupId == 1 || this.state.selectedGroupId == 2 || this.state.selectedGroupId == 4 || this.state.selectedGroupId == 10 ? (<div className="col-md-6" style={{ marginBottom: 0 }}>
                                        <label className="form-label" for="depot">
                                            Work Description
                                        </label>
                                        <Form.Item required tooltip="This is a required field">
                                            <Input placeholder=" Work Description" id="work_des" value={this.state.workDescription} onChange={this.handleChangeWorkDes} />
                                        </Form.Item>

                                    </div>) : ('')}

                                    {this.state.selectedGroupId == 2 ? (<div className="col-md-6">


                                        <label className="form-label" for="depot">
                                            Work Type
                                        </label>
                                        <Select
                                            //showSearch
                                            onChange={this.onChangeVisitingPurpose}

                                            defaultValue={this.state?.visitingPurpose?.id}
                                            style={{ width: "100%" }}
                                            placeholder="Search to Select"
                                            optionFilterProp="children"

                                        >
                                            {this.state.SiteAccessBaseDataVisitingPurposes.map((item, index) => {
                                                return <Option value={item.id}>{item.name} </Option>;
                                            })}
                                        </Select>

                                    </div>) : ('')}

                                    {this.state.selectedGroupId == 2 ? (<div className="col-md-6">


                                        <label className="form-label" for="depot">
                                            Access Need
                                        </label>
                                        <Select
                                            //showSearch
                                            onChange={this.onChangeAccessNeed}
                                            defaultValue={this.state?.accessNeed?.id}
                                            style={{ width: "100%" }}
                                            placeholder="Search to Select"
                                            optionFilterProp="children"

                                        >
                                            {this.state.SiteAccessBaseDataAccessNeed.map((item, index) => {
                                                return <Option value={item.id}>{item.name} </Option>;
                                            })}
                                        </Select>

                                    </div>) : ('')}
                                    {this.state.selectedGroupId == 2 ? (<div className="col-md-6">


                                        <label className="form-label" for="depot">
                                            Related Technologys
                                        </label>
                                        <Select
                                            //showSearch
                                            onChange={this.onChangerelatedTechnology}
                                            defaultValue={this.state?.relatedTechnology?.id}

                                            style={{ width: "100%" }}
                                            placeholder="Search to Select"
                                            optionFilterProp="children"

                                        >
                                            {this.state.SiteAccessBaseDatarelatedTechnologys.map((item, index) => {
                                                return <Option value={item.id}>{item.name} </Option>;
                                            })}
                                        </Select>

                                    </div>) : ('')}

                                    {this.state.selectedGroupId == 3 ? (<div className="col-md-6" style={{ marginBottom: 0 }}>
                                        <label className="form-label" for="depot">
                                            Reason
                                        </label>
                                        <Form.Item required tooltip="This is a required field">
                                            <Input placeholder="Reason" />
                                        </Form.Item>

                                    </div>) : ('')}
                                    {this.state.selectedGroupId == 4 ? (<div className="col-md-6" style={{ marginBottom: 0 }}>
                                        <label className="form-label" for="depot">
                                            Project Name
                                        </label>
                                        <Form.Item required tooltip="This is a required field">
                                            <Input placeholder="Reason" />
                                        </Form.Item>

                                    </div>) : ('')}

                                    {this.state.selectedGroupId == 10 ? (
                                        <div className='row'><div className="col-md-6" style={{ marginBottom: 0 }}>
                                            <label className="form-label" for="depot">
                                                Remarks
                                            </label>
                                            <Form.Item required tooltip="This is a required field">
                                                <Input placeholder="Reason" value={this.state.workRemarks} onChange={this.handleRemarks} />
                                            </Form.Item>

                                        </div>
                                            <div className="col-md-6" style={{ marginBottom: 0 }}>
                                                <label className="form-label" for="depot">
                                                    Work Type
                                                </label>
                                                <Select
                                                    //showSearch
                                                    onChange={this.onChangeWorkType}

                                                    //defaultValue={[]}
                                                    defaultValue={this.state?.workType?.id}
                                                    style={{ width: "100%" }}
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"

                                                >
                                                    {this.state.selectWorkType.map((item, index) => {
                                                        return <Option value={item.id}>{item.name} </Option>;
                                                    })}
                                                </Select>

                                            </div>
                                            <div className="col-md-6" style={{ marginBottom: 0 }}>
                                                <label className="form-label" for="depot">
                                                    Work Area
                                                </label>
                                                <Select
                                                    //showSearch
                                                    onChange={this.onChangeWorkArea}

                                                    defaultValue={this.state?.workArea?.id}
                                                    style={{ width: "100%" }}
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"

                                                >
                                                    {this.state.selectWorkArea.map((item, index) => {
                                                        return <Option value={item.id}>{item.name} </Option>;
                                                    })}
                                                </Select>

                                            </div>
                                        </div>

                                    ) : ("")}



                                </div>

                                <br></br>
                                {this.state.submit_loading ? (<ReactLoading
                                    type={"bars"}
                                    color={"#03fc4e"}
                                    height={86}
                                    width={100}

                                // style={{color:"#03fc4e",flex: 0.1}} 
                                />) : (<button
                                    className="btn btn-primary"
                                    onClick={() => this.AllDataSubmit()}
                                >
                                    Submit
                                </button>)}


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    //console.log("state", state);
    return {
        organization_count: state.organization.length,
        regions: state.regions,
        depots: state.depots,
        sites_count: state.sites.length,
        vendor_count: state.vendor.length,
        roles_count: state.roles.length,
    };
}
export default withRouter(connect(mapStateToProps, { getDonationCategories, getData })(Edit)); 